const weightUnitConstants = {
	poundsAndOunces: 'Pounds and Ounces',
	kilograms: 'Kilograms',
};

const dimensionUnitConstants = {
	inches: 'Inches',
	meters: 'Meters',
};

export { weightUnitConstants, dimensionUnitConstants };



// WEBPACK FOOTER //
// ./src/common/constants/productConstants.js